import { v4 as uuid } from "uuid";
const key = "customerToken";

export const getCustomerToken = () => {
	let token = localStorage.getItem(key);
	if (!token) {
		token = uuid();
		localStorage.setItem(key, token);
	}
	return token;
};

export const clearCustomerToken = () => {
	localStorage.removeItem(key);
};

export default {
	getCustomerToken,
	clearCustomerToken,
};
